var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_241622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7918 18.1256C14.3371 18.1256 18.4652 11.8729 18.4652 6.45216C18.4652 6.27638 18.4613 6.09669 18.4535 5.92091C19.2566 5.34016 19.9496 4.62082 20.5 3.79669C19.7521 4.12944 18.958 4.34676 18.1449 4.44122C19.0011 3.92803 19.6421 3.12184 19.9492 2.17208C19.1438 2.64941 18.263 2.98612 17.3445 3.16779C16.7257 2.51024 15.9075 2.07487 15.0164 1.92899C14.1253 1.7831 13.211 1.93482 12.4148 2.36069C11.6186 2.78656 10.9848 3.46286 10.6115 4.28504C10.2382 5.10721 10.1462 6.02946 10.3496 6.90919C8.71874 6.82735 7.12328 6.4037 5.66665 5.66569C4.21002 4.92769 2.92474 3.89181 1.89414 2.62521C1.37033 3.52831 1.21005 4.59698 1.44586 5.61402C1.68167 6.63106 2.29589 7.52015 3.16367 8.1006C2.51219 8.07991 1.87498 7.90451 1.30469 7.58888V7.63966C1.3041 8.5874 1.63175 9.5061 2.23192 10.2396C2.8321 10.9731 3.66777 11.4761 4.59687 11.6631C3.99338 11.8282 3.35999 11.8523 2.7457 11.7334C3.00788 12.5485 3.51798 13.2614 4.20481 13.7726C4.89164 14.2838 5.72093 14.5678 6.57695 14.585C5.12369 15.7265 3.32848 16.3457 1.48047 16.3428C1.15274 16.3423 0.825333 16.3222 0.5 16.2826C2.37738 17.4871 4.56128 18.1268 6.7918 18.1256Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_241622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1c75a2aadcf237b1f8b811007715d6a3.svg";
export { ForwardRef as ReactComponent };